@if (atgard) {
  <div>
    <rask-simple-selector
      #planeringsstatusSelector
      class="col-5"
      label="Planeringsstatus"
      (change)="onPlaneringsstatusChange(planeringsstatusSelector.value)"
      [values]="atgardPlaneringsstatusLista"
      bindLabel="value"
      bindValue="value"
      [clearable]="false"
      [disabled]="atgard.isUtfort || kontraktReadonly"
      [value]="atgard.status">
    </rask-simple-selector>
    <rask-textmultiline label="Produktionsstatus" [value]="$safeNavigationMigration(atgard.arbetsorder?.produktionsStatus) | produktionsstatus"></rask-textmultiline>
    <div class="hr-div">
      <hr />
    </div>
    <div class="row">
      <div class="col-7 changebutton">
        @if (showChangeButton) {
          <rask-action-button
            aid="buttonChangeAtgardTyp"
            alignment="left"
            icon="far fa-edit"
            [showChevron]="false"
            (click)="openchangeTypeDialog()">
            Ändra åtgärdstyp
          </rask-action-button>
        }
      </div>
      <div class="col-5">
        <rask-button
          class="mt-0 deleteButton"
          aid="buttonTaBortAtgard"
          color="primary"
          (click)="onRemoveAtgard()"
          [disabled]="kontraktReadonly || atgard.isUtfort"
          negative>Ta bort åtgärd
        </rask-button>
      </div>
    </div>
  </div>
}